import BentoCaseStudy from "../../components/BentoCaseStudy";
import flynasImpact from "../../constrains/cases/flynasImpact";

export default function FlynasImpact() {
  return <BentoCaseStudy caseStudy={flynasImpact} />;
}
